import { Flame, CloudFog, Waves, CloudRain } from "lucide-react";

// Four core feelings the app helps with. Age-neutral wording that works for children,
// adolescents, and adults. Colors are saturated but grounded — vibrant enough to feel
// alive, muted enough to feel clinical.
export const FEELINGS = [
  {
    key: "anger",
    label: "Anger",
    prompt: "Angry",
    subtitle: "Frustrated · mad · fired up",
    icon: Flame,
    color: "#C0472A",         // vivid terracotta
    bg: "#FDDDCE",
    border: "#F5B79C",
    accent: "#EF6E42",
  },
  {
    key: "fear",
    label: "Fear",
    prompt: "Afraid",
    subtitle: "Anxious · worried · nervous",
    icon: CloudFog,
    color: "#2A5AA0",         // rich indigo
    bg: "#DDE8F8",
    border: "#B0C6E6",
    accent: "#5A85CB",
  },
  {
    key: "overwhelm",
    label: "Overwhelm",
    prompt: "Overwhelmed",
    subtitle: "Too much · buzzy · flooded",
    icon: Waves,
    color: "#7C3E9C",         // vibrant plum
    bg: "#EBDEF4",
    border: "#CDB1DF",
    accent: "#A96FC4",
  },
  {
    key: "sadness",
    label: "Sadness",
    prompt: "Sad",
    subtitle: "Low · heavy · quiet inside",
    icon: CloudRain,
    color: "#22857B",         // vivid teal
    bg: "#D5F0EC",
    border: "#9DD8D0",
    accent: "#40B3A5",
  },
];

export const FEELING_BY_KEY = Object.fromEntries(FEELINGS.map((f) => [f.key, f]));
